export function throwError(errors: any) {
    if (Array.isArray(errors)) {
        errors.forEach((error) => {
            throw new Error(error.message);
        });
    }
}
